
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PrivacySet extends Vue {
  cellList = [
    {
      title: "相机权限",
      label: "开启后，可实现扫描、照相、录视频",
      icon: require("@/assets/images/shouyin/my/privacySet/camera.png"),
      value: 0, // 1已开启 0去设置
      url: "toCameraSetting",
    },
    {
      title: "通讯录",
      label: "开启后，可快捷填写联系人信息",
      icon: require("@/assets/images/shouyin/my/privacySet/contact.png"),
      value: 0,
      url: "toAddressBookSetting", // iOS不要授权
    },
    {
      title: "位置信息",
      label: "开启后，可快捷填写店铺地址、管理收货地址",
      icon: require("@/assets/images/shouyin/my/privacySet/location.png"),
      value: 0,
      url: "toLocationSetting",
    },
    {
      title: "手机存储",
      label: "开启后，可上传本地图片和视频",
      icon: require("@/assets/images/shouyin/my/privacySet/storage.png"),
      value: 0,
      url: "toStorageSetting", // iOS不要授权
    },
    {
      title: "麦克风",
      label: "开启后，可使用语音识别快捷录入服务",
      icon: require("@/assets/images/shouyin/my/privacySet/microphone.png"),
      value: 0,
      url: "toMicrophoneSetting",
    },
  ];

  mounted() {
    this.getPermissionData();
    this.refreshPage();
  }

  // 原生页面返回无感刷新方式
  refreshPage() {
    this.$bridge.registerHandler(
      "refreshPage",
      (data: string, responseCallback) => {
        // 获取权限数据
        this.getPermissionData();
      }
    );
  }

  // 获取权限数据
  getPermissionData() {
    // 获取-相机权限(0未开通，1 开通)
    this.$bridge.callHandler("getCameraPermission", {}, (data: any) => {
      this.cellList[0].value = Number(data);
    });
    // 获取-通讯录权限(0未开通，1 开通)
    this.$bridge.callHandler("getAddressBookPermission", {}, (data: any) => {
      this.cellList[1].value = Number(data);
    });
    // 获取-定位权限(0未开通，1 开通)
    this.$bridge.callHandler("getLocationPermission", {}, (data: any) => {
      this.cellList[2].value = Number(data);
    });
    // 获取-手机存储权限(0未开通，1 开通)
    this.$bridge.callHandler("getStoragePermission", {}, (data: any) => {
      this.cellList[3].value = Number(data);
    });
    // 获取-麦克风(false未开通，true 开通)
    this.$bridge.callHandler("getMicrophonePermission", {}, (data: any) => {
      this.cellList[4].value = Number(data);
    });
  }

  onCellItemClick(item) {
    const { url } = item;
    url && this.$bridge.callHandler(url);
  }
}
